import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import useLenis from "@/hooks/useLenis";

/**
 * SubpageLayout — minimal editorial chrome for /privacy and /work/:id.
 * A simplified sticky header (Depmont logo + Back link) plus the main footer.
 * Uses <Link> so left-click routes in-page, right-click still offers "Open in new tab".
 */
export default function SubpageLayout({ children, back = { to: "/", label: "Back" } }) {
    useLenis();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#F6F3EC] text-[#1B1B1B] min-h-screen flex flex-col">
            <header className="sticky top-0 z-40 bg-[#F6F3EC]/90 backdrop-blur-sm border-b border-[#E6E2D6]">
                <div className="mx-auto max-w-[1800px] px-6 md:px-12 lg:px-20 h-16 md:h-20 flex items-center justify-between">
                    <Link
                        to="/"
                        className="font-sans-tight text-[15px] tracking-[0.36em] uppercase font-medium text-[#1B1B1B]"
                    >
                        Depmont
                    </Link>
                    <Link
                        to={back.to}
                        className="eyebrow link-underline text-[#1B1B1B]/80"
                    >
                        ← {back.label}
                    </Link>
                </div>
            </header>

            <main className="flex-1">{children}</main>

            <Footer />
            <BackToTop />
        </div>
    );
}
